import React, { useState } from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import { useTranslation } from 'react-i18next'
import OInputField from 'components/reusable/OInputField'
import { numericInputPattern, preventMaxInput } from 'utils/validations'
import formValidation from '../../utils/formValidation'

const CountryEdit = ({ allCountry, currentItem, handleEdit }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const [isLoading, setIsLoading] = useState(false)

  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      name: currentItem?.name,
      countryCode: '+' + currentItem?.countryCode
    }
  })

  const onSubmit = async data => {
    try {
      setIsLoading(true)
      data.name = data?.name?.trim()
      data.countryCode = data?.countryCode?.trim().slice(1)
      var path = apiPath.countryUpdate + '/' + currentItem._id
      const result = await apiPut(path, data)
      if (result.data.success) {
        allCountry()
        handleEdit(false)
        notification.success(result?.data.message)
      } else {
        notification.error(result?.data.message)
      }
    } catch (error) {
      console.log('error in get all users list==>>>>', error)
      notification.error(error.message)
    }
    setIsLoading(false)
  }

  const handleDecimalOffer = e => {
    var value = e.target.value
    setValue('countryCode', '+' + value.slice(1))
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto outline-none focus:outline-none fixed inset-0 z-50 '>
        <div className='relative w-auto mx-auto max-w-3xl my-6'>
          <div className='md:py-4 sm:py-8 px-7 sm:px-2'>
            <div className='shadow-lg relative flex flex-col w-full border-0 rounded-lg bg-white outline-none focus:outline-none min-w-[550px]'>
              <div className='justify-between p-5 border-b border-solid flex items-center border-slate-200 rounded-t'>
                <h3 className='font-semibold text-xl'>{t('EDIT_COUNTRY')}</h3>
                <button
                  className=' justify-center  text-black border-2 rounded-full ml-auto flex items-center h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => handleEdit(false)}
                  title='Close'
                >
                  <span className='text-4xl text-[#B8BBBF]'>×</span>
                </button>
              </div>
              {/*body*/}
              <div className='p-6 relative flex-auto'>
                <div className='grid sm:grid-cols-2'>
                  <div className='md:py-4 px-7 sm:px-2 sm:py-8'>
                    <div className='z-0 w-full group relative '>
                      <OInputField
                        name='countryCode'
                        id='countryCode'
                        autoFocus={true}
                        wrapperClassName='relative z-0 w-full group'
                        type='text'
                        inputLabel={
                          <>
                            {t('COUNTRY_CODE')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        onKeyDown={event => numericInputPattern(event)}
                        placeholder=''
                        maxLength={4}
                        onInput={e => preventMaxInput(e, 4)}
                        register={register('countryCode', {
                          required: 'Please enter country code.',
                          min: {
                            value: 1,
                            message: 'Minimum value must is 1.'
                          },
                          onChange: e => handleDecimalOffer(e)
                        })}
                        errors={errors}
                      />
                    </div>
                  </div>
                  <div className='md:py-4 sm:py-8 px-7 sm:px-2 '>
                    <div className='w-full group relative z-0 '>
                      <OInputField
                        id='name'
                        wrapperClassName='relative z-0 w-full group'
                        type='text'
                        name='name'
                        maxLength={30}
                        inputLabel={
                          <>
                            {t('COUNTRY')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        register={register(
                          'name',
                          formValidation['countryName']
                        )}
                        placeholder=''
                        onInput={e => preventMaxInput(e, 30)}
                        errors={errors}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='border-t flex items-center justify-center p-6 border-solid border-slate-200 rounded-b'>
                <button
                  onClick={() => handleEdit(false)}
                  className='text-black bg-[#E1E1E1] focus:outline-none rounded mr-6 font-normal px-12 py-2.5 text-sm outline-none ease-linear transition-all duration-150'
                  type='button'
                >
                  {t('O_BACK')}
                </button>
                {isLoading ? (
                  <div className='active:bg-emerald-600 spinner-container bg-LightBlue text-white font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'>
                    <div className='loading-spinner'></div>
                  </div>
                ) : (
                  <button
                    type='submit'
                    className='active:bg-emerald-600 px-8 py-2.5 font-normal text-sm bg-LightBlue text-white rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                    onClick={handleSubmit(onSubmit)}
                  >
                    {t('O_SAVE')}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='fixed inset-0 opacity-25 z-40 bg-black' />
    </>
  )
}

export default CountryEdit
